import React from 'react';

const Register: React.FC = () => {
  return (
    <div className="max-w-md mx-auto">
      <div className="card">
        <h1 className="text-3xl font-bold text-navy-950 dark:text-white mb-8 text-center">
          Join the Brotherhood
        </h1>
        <p className="text-center text-gray-600 dark:text-gray-300 mb-8">
          Registration coming soon...
        </p>
      </div>
    </div>
  );
};

export default Register;
